/* istanbul ignore file */
import type { MfeConfig, OverridesMap } from "./DeveloperWorkbench.types";

export const STORAGE_KEY = "wealthiq-mfe-overrides";

export const MFE_CONFIGS: MfeConfig[] = [
  {
    key: "mfe-investing",
    name: "Investing MFE (Federated)",
    defaultScriptUrl: "http://localhost:5005/remoteEntry.js",
  },
  {
    key: "vue-settings-mfe",
    name: "Vue Settings MFE",
    defaultScriptUrl: "https://wealthiq.bfme.co.in/mfe-vue-settings/main.js",
  },
  {
    key: "react-dashboard-mfe",
    name: "React Dashboard MFE (Federated)",
    defaultScriptUrl:
      "https://wealthiq.bfme.co.in/mfe-react-dashboard/remoteEntry.js",
  },
  {
    key: "mfe-expense-manager",
    name: "Expense Manager MFE (Federated)",
    defaultScriptUrl: "http://localhost:5000/remoteEntry.js",
  },
  {
    key: "mfe-charting",
    name: "Charting MFE (Federated)",
    defaultScriptUrl: "http://localhost:5001/remoteEntry.js",
  },
];

export const checkDeveloperMode = (): boolean => {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  if (params.get("developer") === "1") return true;

  const processDevMode =
    typeof process !== "undefined" && process.env
      ? process.env.VITE_ENABLE_DEV_WORKBENCH === "true" ||
        process.env.VITE_TEST_ENV === "true"
      : false;

  let metaDevMode = false;
  try {
    const metaEnv = new Function("return import.meta.env")();
    metaDevMode =
      metaEnv?.VITE_ENABLE_DEV_WORKBENCH === "true" ||
      metaEnv?.VITE_TEST_ENV === "true";
  } catch {
    // Ignore error in non-ESM/Jest environment
  }

  return processDevMode || metaDevMode;
};

/**
 * Retrieves the currently saved overrides map from LocalStorage.
 */
export const getStoredOverrides = (): OverridesMap => {
  if (typeof window === "undefined") return {};
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    console.error("Error reading MFE overrides from localStorage:", error);
    return {};
  }
};

/**
 * Saves the overrides map to LocalStorage.
 */
export const setStoredOverrides = (overrides: OverridesMap): void => {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(overrides));
  } catch (error) {
    console.error("Error saving MFE overrides to localStorage:", error);
  }
};

export const clearStoredOverrides = (): void => {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error("Error clearing MFE overrides from localStorage:", error);
  }
};

/**
 * Reloads the page to apply changes.
 */
export const reloadPage = (): void => {
  if (typeof window !== "undefined") {
    window.location.reload();
  }
};
